import { useTranslation } from "react-i18next";
import Breadcrumb from "../../components/Breadcrumb";
import date from '../../../assets/img/utils/date.svg';

// Mirrors the Word announcement: Arial 12pt, 1.5 line spacing, 8pt after paragraphs, blue (#0000FF) dates
// (font props are repeated on p/li because the site's global p styles override inherited ones)
const elanFont = { fontFamily: 'Arial, sans-serif', fontSize: '12pt', lineHeight: 1.5, color: '#000' }
const elanStyles = {
    wrapper: elanFont,
    p: { ...elanFont, textAlign: 'justify', marginBottom: '8pt' },
    center: { textAlign: 'center' },
    blue: { color: '#0000FF' },
    link: { fontSize: 'inherit', lineHeight: 'inherit', color: '#0563C1' }, // underline sits on the inner <i>: a global `a` rule forces none !important
    list: { listStyleType: 'disc', paddingLeft: '0.5in', marginBottom: '8pt' },
    li: { ...elanFont, textAlign: 'justify' }
}

const IctimaiSura = () => {
    const { t } = useTranslation()

    const breadcrumb = [
        {
            id: 1,
            link: '/agentlik/haqqimizda',
            title: t('agentlik:about'),
            isActive: false
        },
        {
            id: 2,
            link: '/agentlik/nizamname',
            title: t('agentlik:order'),
            isActive: false
        },
        {
            id: 3,
            link: '/agentlik/rehberlik',
            title: t('agentlik:management'),
            isActive: false
        },
        {
            id: 4,
            link: '/agentlik/mida-mmc',
            title: t('agentlik:mida_mmc'),
            isActive: false
        },
        {
            id: 5,
            link: '/agentlik/beynelxalq-emekdasliq',
            title: t('agentlik:international'),
            isActive: false
        },
        {
            id: 6,
            link: '/agentlik/hesabatlar',
            title: t('agentlik:audits'),
            isActive: false
        },
        {
            id: 7,
            link: '/agentlik/ictimai-sura',
            title: "İctimai şura",
            isActive: true
        }
    ]

    const sections = [
        {
            id: 1,
            target: 'suraCollapse1',
            title: 'Elan',
            content: (
                <div style={elanStyles.wrapper}>
                    <p style={{ ...elanStyles.p, ...elanStyles.center, marginBottom: 0 }}><b>Azərbaycan Respublikasının Mənzil İnşaatı Dövlət Agentliyi yanında</b></p>
                    <p style={{ ...elanStyles.p, ...elanStyles.center, marginBottom: 0 }}><b>İctimai şuraya seçkilərlə əlaqədar</b></p>
                    <p style={{ ...elanStyles.p, ...elanStyles.center }}><b>Elan</b></p>
                    <p style={elanStyles.p}>
                        Vətəndaş cəmiyyəti institutlarının diqqətinə çatdırılır ki, <b>Azərbaycan Respublikasının Mənzil İnşaatı Dövlət Agentliyi</b> yanında İctimai şuraya namizədlərin irəli sürülməsi və qeydiyyatı elan olunur.
                    </p>
                    <p style={elanStyles.p}>
                        "İctimai iştirakçılıq haqqında” Azərbaycan Respublikasının 2013-cü il 22 noyabr tarixli 816-IVQ nömrəli Qanunu və Azərbaycan Respublikası Nazirlər Kabinetinin 2014-cü il 30 may tarixli 171 nömrəli Qərarı ilə təsdiq edilmiş “İctimai şuranın vətəndaş cəmiyyəti institutları tərəfindən seçilməsinə dair Əsasnamə”yə uyğun olaraq Azərbaycan Respublikasının Mənzil İnşaatı Dövlət Agentliyi yanında İctimai şura üzvlüyünə namizədlərin irəli sürülməsi prosesinə 20.10.2026-cı il tarixindən başlanılıb. Namizədlərin irəli sürülməsi və qeydə alınması prosesi 20 iş günü müddətində həyata keçiriləcək və 18.11.2026-cı il tarixində saat 17:00-da yekunlaşacaq.
                    </p>
                    <p style={elanStyles.p}>
                        İctimai şura üzvlərinin say həddi 5 nəfər müəyyən edilib. Hər bir vətəndaş cəmiyyəti institutu İctimai şura üzvlüyünə yalnız bir namizəd irəli sürə bilər.
                    </p>
                    <p style={elanStyles.p}>
                        <b><i>Azərbaycan Respublikasının Mənzil İnşaatı Dövlət Agentliyi yanında İctimai şura üzvlüyünə namizədlərə dair tələblər:</i></b>
                    </p>
                    <p style={elanStyles.p}>
                        İctimai şuraya milliyyətindən, dilindən, dinindən, irqindən, cinsindən, mənşəyindən, əmlak vəziyyətindən, qulluq mövqeyindən, əqidəsindən, siyasi partiyalara, həmkarlar ittifaqlarına və digər ictimai birliklərə mənsubiyyətindən asılı olmayaraq, yüksək mənəvi və əxlaqi keyfiyyətlərə, Azərbaycan Respublikasının Mənzil İnşaatı Dövlət Agentliyinin fəaliyyət istiqamətləri üzrə təcrübəyə və ya biliyə malik Azərbaycan Respublikasının 16 yaşına çatmış hər bir fəaliyyət qabiliyyətli vətəndaşı üzv ola bilər.
                    </p>
                    <p style={{ ...elanStyles.p, textAlign: 'left' }}>
                        <b><i>İctimai şuranın üzvlüyünə irəli sürülən namizəd aşağıdakı sənədləri təqdim etməlidir:</i></b>
                    </p>
                    <ul style={elanStyles.list}>
                        <li style={elanStyles.li}>Namizədin şəxsiyyət vəsiqəsinin surəti;</li>
                        <li style={elanStyles.li}>Namizədin tərcümeyi-halı;</li>
                        <li style={elanStyles.li}>Namizəd hər hansı bir vətəndaş cəmiyyəti institutunun üzvü olduğu halda həmin üzvlüyü təsdiq edən sənədin surəti;</li>
                        <li style={elanStyles.li}>Qeyri-kommersiya qurumlarının dövlət reyestrindən çıxarışın surəti;</li>
                        <li style={elanStyles.li}>Şəxsin müvafiq sahə üzrə təcrübəyə və ya biliyə malik olmasını sübut edən sənəd (olduğu halda əmək kitabçasının surəti, əmək kitabçası olmadıqda isə məlumatı təsdiqləyəcək digər sənədlər).</li>
                    </ul>
                    <p style={elanStyles.p}>
                        Tələb olunan sənədlərdən əlavə vətəndaş cəmiyyəti institutu tərəfindən namizəd barədə geniş məlumat verən digər sənədlər də təqdim edilə bilər. Namizədlər qeyd olunan sənədləri <a href='mailto:office@mida.gov.az' style={elanStyles.link}><i style={{ textDecoration: 'underline' }}>office@mida.gov.az</i></a> elektron ünvan vasitəsilə onlayn formada təqdim etməlidirlər.
                    </p>
                    <p style={elanStyles.p}>
                        İctimai şuraya namizədliyi irəli sürmüş şəxsin qeydiyyatına Seçki komissiyası tərəfindən 3 iş günü müddətində baxılacaq və müvafiq qərar qəbul ediləcək.
                    </p>
                    <p style={{ ...elanStyles.p, marginBottom: 0 }}>
                        Əlavə məlumat üçün Seçki komissiyası ilə +994 12 (505 65 37/38) nömrəli telefonla əlaqə saxlanıla bilər.
                    </p>
                    {/* news-item scopes the .news-date stamp styles from the news pages; site font, not the Elan Arial */}
                    <div className='news-item mt-4 d-flex justify-content-center' style={{ fontFamily: 'Helvetica' }}>
                        <small className='news-date fw-normal'><img src={date} alt='date-icon' className='me-2' />20.10.2026</small>
                    </div>
                </div>
            )
        },
        {
            id: 2,
            target: 'suraCollapse2',
            title: 'Tərkib',
            content: 'Tərkib'
        },
        {
            id: 3,
            target: 'suraCollapse3',
            title: 'Xəbərlər',
            content: 'Xəbərlər'
        },
    ]

    return (
        <div className="block-bg1 pt-lg-3 pb-md-5 py-0">
            <Breadcrumb data={breadcrumb} />

            <div className='container px-md-120 mt-4 mt-sm-5 mt-md-5'>
                <div className='block-bg-white px-md-120 px-4 py-md-5 py-4 text-center rounded-4'>
                    <h4 className="heading mb-2 pb-3 t-color5 fw-700">İctimai şura</h4>
                    {/* <div className='px-md-60'>
                        <p className="text-inf">
                            “İctimai iştirakçılıq haqqında” Azərbaycan Respublikasının 2013-cü il 22 noyabr tarixli 816-IVQ nömrəli Qanununa və Azərbaycan Respublikası Nazirlər Kabinetinin 2014-cü il 30 may tarixli 171 nömrəli qərarı ilə təsdiq edilmiş “İctimai şuranın vətəndaş cəmiyyəti institutları tərəfindən seçilməsinə dair Əsasnamə”yə uyğun olaraq Mənzil İnşaatı Dövlət Agentliyi yanında İctimai Şuraya ---- 2026-ci il tarixində seçkilər keçirilmiş, vətəndaş cəmiyyəti institutlarının təmsilçilərinin iştirakı ilə keçirilən seçkilərdə ---- nəfərdən ibarət tərkibdə İctimai Şura formalaşdırılmışdır.
                        </p>
                    </div> */}

                    <div className='accordion text-start mt-4 px-5 mx-3' id='suraAccordion'>
                        {sections.map(item =>
                            <div className='accordion-item border-bottom' key={item.id}>
                                <h2 className='accordion-header' id={'suraHeading' + item.id}>
                                    <button className='accordion-button collapsed' type='button' data-bs-toggle='collapse' data-bs-target={'#' + item.target} aria-expanded='false' aria-controls={item.target}>
                                        {item.title}
                                    </button>
                                </h2>
                                <div id={item.target} className='accordion-collapse collapse' aria-labelledby={'suraHeading' + item.id} data-bs-parent='#suraAccordion'>
                                    <div className='accordion-body px-0 pt-0'>
                                        {typeof item.content === 'string'
                                            ? <p className='mb-0 text-muted'>{item.content}</p>
                                            : item.content}
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default IctimaiSura;
